import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import WelcomeIcon from "../../assets/images/WelcomeIcon.svg";
import jwt_decode from "jwt-decode";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { Helmet } from "react-helmet-async";
import "./Welcome.css";
import call from "../../API/API";

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: undefined,
      lastName: undefined,
      isLoading: true,
    };

    this.handleSkipButton = this.handleSkipButton.bind(this);
    this.handleStartMatchingCriteria = this.handleStartMatchingCriteria.bind(
      this
    );
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (
        this.props.location.state === undefined ||
        !this.props.location.state.userData
      ) {
        if (!decoded.active) {
          this.props.history.push("/");
        } else {
          this.props.history.push("/dashboard");
        }
      } else {
        let userData = this.props.location.state.userData;
        if (!decoded.active) {
          this.props.history.push("/payment", { userData: userData });
        } else {
          let { paymentAcceptedShow } = userData;
          if (paymentAcceptedShow === false) {
            this.props.history.push("/payment-accepted", {
              userData: userData,
            });
          } else {
            //Check if user has matching criteria:
            call.users_API.getPersonalUserMatchingCriteria().then((res) => {
              if (res.success) {
                let { matching_data } = res.results;
                if (matching_data) {
                  //User already has matching criteria => push him to dashboard (this happens when user has re-subscribed)
                  this.props.history.push("/");
                } else {
                  //User doesn't have matching criteria
                  let { name, lastname } = userData;
                  this.setState(
                    {
                      name: name,
                      lastName: lastname,
                    },
                    () => {
                      this.setState({
                        isLoading: false,
                      });
                    }
                  );
                }
              } else {
                this.props.history.push("/error", { error: res.results });
              }
            });
          }
        }
      }
    }
  }

  handleSkipButton(e) {
    e.preventDefault();
    this.props.history.push("/dashboard");
  }

  handleStartMatchingCriteria() {
    let userData = this.props.location.state.userData;
    this.props.history.push("/matching-criteria-1", {
      userData: {
        ...userData,
        matching_criteria: true,
      },
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-welcome"
          hasCounter={false}
          hasQuote={true}
          quote="Let's set your matching criteria. This will help us to connect you with enterpreneurs that you will benefit from."
          headerText={
            this.state.name !== undefined && this.state.lastName !== undefined
              ? "Welcome to Astronomic Network, " +
                this.state.name +
                " " +
                this.state.lastName +
                "!"
              : "Welcome to Astronomic Network!"
          }
          hasImage={true}
          imageSrc={WelcomeIcon}
          imageAlt="Man enjoying victory"
          primaryButtonText="Let's start"
          handlePrimaryBtnOnClick={this.handleStartMatchingCriteria}
          activatePrimaryWithEnter={true}
          showButton={true}
          hasSkip={true}
          handleSkipButton={this.handleSkipButton}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default Welcome;
